import { render, staticRenderFns } from "./HomeResearch.vue?vue&type=template&id=6e2acad5"
import script from "./HomeResearch.vue?vue&type=script&lang=js"
export * from "./HomeResearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports